import { Link } from "react-router-dom";

function crumbIsNavigable(crumb, isLast) {
  if (isLast) return false;
  const p = crumb.path;
  return p != null && String(p).trim() !== "";
}

export default function PageHeader({ title, subtitle, breadcrumbs = [], className = "" }) {
  return (
    <div className={`lfx-page-header ${className}`.trim()}>
      {breadcrumbs.length ? (
        <div className="lfx-breadcrumbs" aria-label="Breadcrumb">
          {breadcrumbs.map((crumb, idx) => {
            const isLast = idx === breadcrumbs.length - 1;
            const canLink = crumbIsNavigable(crumb, isLast);
            return (
              <span key={`${crumb.label}-${idx}`} className="lfx-breadcrumb-item">
                {canLink ? (
                  <Link className="lfx-breadcrumb-link" to={crumb.path}>
                    {crumb.label}
                  </Link>
                ) : (
                  <span className={`lfx-breadcrumb-current ${isLast ? "is-current" : ""}`}>{crumb.label}</span>
                )}
                {!isLast ? <span className="lfx-breadcrumb-sep" aria-hidden> / </span> : null}
              </span>
            );
          })}
        </div>
      ) : null}
      {title ? <h1 className="lfx-page-title">{title}</h1> : null}
      {subtitle ? <p className="lfx-page-subtitle">{subtitle}</p> : null}
    </div>
  );
}
